//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { QuoteId } from '@models/QuoteId';

export enum QuoteState {
  CONTACT_REQUESTED = 'CONTACT_REQUESTED',
  INVOICE_REQUESTED = 'INVOICE_REQUESTED',
}
export interface PatchQuoteStatusRequest {
  quoteId: QuoteId;
  payload: PatchQuoteStatusPayload;
}

export interface PatchQuoteStatusPayload {
  status: QuoteState;
}
